import ar from "./ar";
import en from "./en";

/*
 * offers translations live outside the shared dictionary so only this
 * feature's pages download them.
 */
export const offersTextByLocale = { ar, en };

export function getOffersText(locale) {
  return offersTextByLocale[locale] ?? offersTextByLocale.ar;
}
